module.exports = __webpack_public_path__ + "fonts/PlusJakartaSans-Bold.d19e33ca.ttf";